import { proxy } from 'valtio';
import { CepStateType } from 'modules/maya/basics/types/maya.types';

const cepState = proxy<CepStateType>({
  cep: {},
  tactics: [],
  targetList: [],
});

export default cepState;
